import React, { Component } from "react";
import { subscribeToActivity } from "../../utils/activityIndicator";
import "./globalLoadingBar.css";

// A slim bar across the top of the app, shown while any Firestore read is in
// flight. It replaces nothing and blocks nothing — the page underneath stays
// visible and usable, which is the point: the previous full-page overlay hid
// the page an admin had asked for behind data most of it didn't need.
//
// Two deliberate delays keep it from becoming noise:
//   - it waits before appearing, so the many fetches that finish quickly never
//     flash a bar at anyone;
//   - once shown it stays for a short minimum, so a bar that does appear
//     doesn't vanish faster than the eye can register it.
const SHOW_AFTER_MS = 250;
const MIN_VISIBLE_MS = 400;

class GlobalLoadingBar extends Component {
  state = { visible: false };

  componentDidMount() {
    this.unsubscribe = subscribeToActivity(this.handleActivityChange);
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    clearTimeout(this.showTimer);
    clearTimeout(this.hideTimer);
  }

  handleActivityChange = (busy) => {
    clearTimeout(this.showTimer);
    clearTimeout(this.hideTimer);

    if (busy) {
      if (this.state.visible) return;
      this.showTimer = setTimeout(() => {
        this.shownAt = Date.now();
        this.setState({ visible: true });
      }, SHOW_AFTER_MS);
      return;
    }

    if (!this.state.visible) return;
    const shownFor = Date.now() - (this.shownAt || 0);
    const remaining = Math.max(0, MIN_VISIBLE_MS - shownFor);
    this.hideTimer = setTimeout(
      () => this.setState({ visible: false }),
      remaining,
    );
  };

  render() {
    if (!this.state.visible) return null;
    return (
      <div className="alg-loading-bar" role="status" aria-live="polite">
        <div className="alg-loading-bar-track">
          <span className="alg-loading-bar-fill" />
        </div>
        <span className="alg-loading-bar-label">Loading data</span>
      </div>
    );
  }
}

export default GlobalLoadingBar;
